import { createSvgIcon } from '@mui/material/utils';

export default createSvgIcon(
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14">
        <g>
            <rect
                className="d"
                fill="none"
                stroke="currentColor"
                x=".5"
                y=".5"
                width="9"
                height="9"
            />
            <rect
                className="d"
                fill="none"
                stroke="currentColor"
                x="4.5"
                y="4.5"
                width="9"
                height="9"
            />
            <rect
                className="e"
                fill="currentColor"
                x="4.5"
                y="4.5"
                width="5"
                height="5"
            />
        </g>
    </svg>,
    'React'
);
